module.exports = __webpack_public_path__ + "img/mr.aa9221fe.png";